import { useState } from 'react';

import * as graphql from '@treams/treams-network';

import { useErrorBoundary } from './useErrorBoundary';

export function useUploadAsset<T extends Blob>(
	mutation?: (id: string, file: T) => Promise<void>,
): [(file: T) => Promise<graphql.Asset>, { loading: boolean; error?: Error }] {
	const [loading, setLoading] = useState(false);
	const [error, attempt] = useErrorBoundary();
	const [createAsset] = graphql.useCreateAssetMutation();

	async function upload(file: T) {
		setLoading(true);

		const { data: createAssetData } = await createAsset({
			variables: {
				input: {
					contentLength: file.size,
					contentType: file.type,
				},
			},
		});

		const { asset, uploadEndpoint } = createAssetData!.createAsset;

		const headers = new Headers();

		for (const { name, values } of uploadEndpoint.headers) {
			for (const value of values) {
				headers.append(name, value);
			}
		}

		await fetch(uploadEndpoint.url, {
			method: 'PUT',
			headers,
			body: file,
		});

		await mutation?.(asset.id, file);

		setLoading(false);

		return asset as graphql.Asset;
	}

	return [attempt(upload), { loading: loading && !error, error }];
}
